$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".hk-play-button", function (e) {
     var video = jQuery(this).parents('.hk-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.hk-video-wrapper').removeClass('active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.hk-video-wrapper').addClass('active');
     jQuery(this).addClass('active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});



$(document).on("click", ".hk-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.hk-question').removeClass('active');
    jQuery('.hk-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});

$(document).on("click", ".hk-drawer-menu-inner a.hk-parent-link", function (e) {
  e.preventDefault();
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.hk-drawer-menu-inner a.hk-parent-link').removeClass('active');
    jQuery('.hk-drawer-menu-inner a.hk-parent-link').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", "a[href='/#faq']", function (e) {
  const target = document.querySelector('.hk-faq');

  if (target) {
    e.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth'
    });
  }
  // else: do nothing → browser follows the link normally
});
$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.hk-element-sub-option').scrollIntoView({
    behavior: 'smooth'
  })
});


$(document).on("click", ".hk-mobile-menu-button", function (e) {
    $('.hk-drawer-menu').addClass('active');
    $('.hk-drawer-menu-bg').show();
    $('body').addClass('hk-overflow-hidden');
});
$(document).on("click", ".hk-mobile-menu-close", function (e) {
    $('.hk-drawer-menu').removeClass('active');
    $('.hk-drawer-menu-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});

$(document).on("click", ".hk-drawer-menu-bg", function (e) {
    $('.hk-drawer-menu').removeClass('active');
    $('.hk-drawer-menu-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});




$(document).on("click", ".hk-element-option", function(e) {
$(this).parents('.hk-product').find('.hk-element-option').removeClass('active');
$(this).addClass('active');
var data_tab = $(this).attr('data_tab');
$(this).parents('.hk-product').find('.hk-quantity-data').hide();
$(this).parents('.hk-product').find('.hk-quantity-data[data_tab="'+data_tab+'"]').show();
});


$(document).on("click", ".hk-element-sub-option:not(.hk-active)", function(e) {
$(this).addClass('hk-active');
var sub_tab = '1';
$(this).parents('.hk-product').find('.hk-sub-trigger').hide().removeClass('hk-active');
$(this).parents('.hk-product').find('.hk-sub-trigger[sub_tab="'+sub_tab+'"]').show().addClass('hk-active');
});

$(document).on("click", ".hk-element-sub-option.hk-active", function(e) {
$(this).removeClass('hk-active');
var sub_tab = '2';
$(this).parents('.hk-product').find('.hk-sub-trigger').hide().removeClass('hk-active');
$(this).parents('.hk-product').find('.hk-sub-trigger[sub_tab="'+sub_tab+'"]').show().addClass('hk-active');
});











$(document).on("click", ".hk-cart-button", function (e) {
document.querySelector('cart-drawer')?.open();
});






 $(document).on("click", '.hk-atc-js', function (e) {
  e.preventDefault();
  var $btn = $(this);
  // prevent multiple clicks
  if ($btn.hasClass('hk-loading')) return;

  $btn.addClass('hk-loading');
  var items = [];
  // main product
  var variant_id = $btn.attr('variant_id');
  var selling_plan = $btn.attr('selling_plan');
  var item = {
    id: parseInt(variant_id),
    quantity: 1
  };

  // add selling plan if exists
  if (selling_plan) {
    item.selling_plan = parseInt(selling_plan);
  }

  items.push(item);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({
      items: items
    }),
    dataType: 'json',
    contentType: 'application/json',

    success: function () {


    },

    complete: function () {
      setTimeout(function () {
        $btn.removeClass('hk-loading');
        // Refresh cart drawer content
fetch('/?section_id=cart-drawer')
  .then((response) => response.text())
  .then((html) => {
    const parser = new DOMParser();
    const newDoc = parser.parseFromString(html, 'text/html');

    const newDrawer = newDoc.querySelector('cart-drawer');
    const currentDrawer = document.querySelector('cart-drawer');

    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;
    }

    // Open drawer after refresh
    document.querySelector('cart-drawer.drawer')?.classList.remove('is-empty');
    currentDrawer?.open();
  });
      }, 500);
    }
  });

});


$(document).on('click', '.hk-pdp-input-plus', function () {
    var $input = $('.hk-pdp-input');
    var $minus = $('.hk-pdp-input-minus');

    var value = parseInt($input.val() || 1, 10);
    value++;

    $input.val(value);

    if (value > 1) {
        $minus.prop('disabled', false);
    }
});

$(document).on('click', '.hk-pdp-input-minus', function () {
    var $input = $('.hk-pdp-input');
    var $minus = $('.hk-pdp-input-minus');

    var value = parseInt($input.val() || 1, 10);

    if (value > 1) {
        value--;
        $input.val(value);
    }

    if (value <= 1) {
        $minus.prop('disabled', true);
        $input.val(1);
    }
});




$(document).on("click", "a[href='#bundle_atc']", function (e) {
  e.preventDefault();
var $btn = $(this);
  // prevent multiple clicks
  if ($btn.hasClass('hk-loading')) return;

  $btn.addClass('hk-loading');
  var items = [];
  // main product


  $('.hk-video-list1-item:not(.hk-free-bundle-item)').each(function(){
 var variant_id = $(this).attr('variant_id');
  var item = {
    id: parseInt(variant_id),
    quantity: 1
  };
  items.push(item);
  });
 

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({
      items: items
    }),
    dataType: 'json',
    contentType: 'application/json',

    success: function () {

    },

    complete: function () {
      setTimeout(function () {
        $btn.removeClass('hk-loading');
        // Refresh cart drawer content
fetch('/?section_id=cart-drawer')
  .then((response) => response.text())
  .then((html) => {
    const parser = new DOMParser();
    const newDoc = parser.parseFromString(html, 'text/html');

    const newDrawer = newDoc.querySelector('cart-drawer');
    const currentDrawer = document.querySelector('cart-drawer');

    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;
    }

    // Open drawer after refresh
    document.querySelector('cart-drawer.drawer')?.classList.remove('is-empty');
    currentDrawer?.open();
  });
      }, 500);
    }
  });
});




$(document).ready(function(){

    const currentPath = window.location.pathname;

    // CATEGORY TABS
    let categoryActiveFound = false;

    $('.hk-categories-tab').each(function(){

        const $tab = $(this);
        const link = $tab.find('a').attr('href');

        if(!link) return;

        const linkPath = new URL(link, window.location.origin).pathname;

        if(linkPath === currentPath){

            $tab.addClass('hk-active');
            categoryActiveFound = true;

        } else {

            $tab.removeClass('hk-active');

        }

    });

    if(!categoryActiveFound){

        $('.hk-categories-tab').first().addClass('hk-active');

    }
if(window.innerWidth < 915){
    const $container = $('.hk-categories-tabs');
    const $active = $('.hk-categories-tab.hk-active');

    if($active.length){

        const left =
            $active.position().left +
            $container.scrollLeft() -
            16;

        $container.animate({
            scrollLeft: left
        }, 400);

    }
  }


    // COLLECTION LINKS
    let collectionActiveFound = false;

    $('.hk-collection-link').each(function(){

        const $link = $(this);
        const href = $link.find('a').attr('href');

        if(!href) return;

        const linkPath = new URL(href, window.location.origin).pathname;

        if(linkPath === currentPath){

            $link.addClass('hk-active');
            collectionActiveFound = true;

        } else {

            $link.removeClass('hk-active');

        }

    });

    if(!collectionActiveFound){

        $('.hk-collection-link').first().addClass('hk-active');

    }

});




$(document).on("click", "a.hk-search-icon", function (e) {
  e.preventDefault();
 $('.hk-header details-modal.header__search summary.header__icon').trigger('click');
});


/* ---------------- Header cart count ---------------- */

function hkUpdateCartCount() {
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.hk-cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    })
    .catch(function () {});
}

$(function () {
  hkUpdateCartCount();

  var drawer = document.querySelector('cart-drawer');
  if (!drawer || !window.MutationObserver) return;

  var timer = null;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(hkUpdateCartCount, 250);
  }).observe(drawer, { childList: true, subtree: true });
});